/* The landing page's few moving parts: a board row opens that machine's sheet, a screenshot opens large, the command
   list opens from the agents section, and copy buttons. Sheets are native <dialog>s: Escape and the close button work
   without help; a click on the backdrop closes one too. */

document.documentElement.classList.add("js");

function openDialog(id: string) {
  const d = document.getElementById(id);
  if (d instanceof HTMLDialogElement) d.showModal();
}

for (const row of document.querySelectorAll<HTMLButtonElement>(".row[data-os]")) {
  row.setAttribute("aria-haspopup", "dialog");
  row.addEventListener("click", () => openDialog(`os-${row.dataset.os}`));
}
for (const b of document.querySelectorAll<HTMLButtonElement>("[data-dialog]")) {
  b.setAttribute("aria-haspopup", "dialog");
  b.addEventListener("click", () => openDialog(b.dataset.dialog!));
}

// the film: its poster and source from data attributes, since the bundler would try to resolve them as files
const film = document.getElementById("film") as HTMLVideoElement | null;
if (film?.dataset.src) {
  if (film.dataset.poster) film.poster = film.dataset.poster;
  const source = document.createElement("source");
  source.src = film.dataset.src;
  source.type = "video/mp4";
  film.replaceChildren(source);
}

// a YouTube video: its picture until it is played, then YouTube's player in its place (the cookie-less one, and
// nothing from YouTube before the click)
for (const a of document.querySelectorAll<HTMLAnchorElement>("a.yt[data-yt]")) {
  a.addEventListener("click", (e) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return; // ⌘-click: YouTube in a tab, as a link does
    e.preventDefault();
    const f = document.createElement("iframe");
    f.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(a.dataset.yt!)}?autoplay=1&rel=0&playsinline=1`;
    f.title = a.closest(".video")?.querySelector("h3")?.textContent ?? "Video";
    f.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
    f.allowFullscreen = true;
    f.referrerPolicy = "strict-origin-when-cross-origin";
    f.className = "yt-frame";
    a.replaceWith(f);
    f.focus();
  });
}

// a screenshot, large
const picture = document.getElementById("picture") as HTMLDialogElement | null;
const pictureImg = document.getElementById("picture-img") as HTMLImageElement | null;
for (const b of document.querySelectorAll<HTMLButtonElement>(".shot-button")) {
  const img = b.querySelector("img");
  if (!img) continue;
  b.setAttribute("aria-label", `Show larger: ${img.alt}`);
  b.addEventListener("click", () => {
    if (!picture || !pictureImg) return;
    pictureImg.src = img.currentSrc || img.src;
    pictureImg.alt = img.alt;
    picture.showModal();
  });
}

// a click outside a sheet's box (on its backdrop) closes it
for (const d of document.querySelectorAll<HTMLDialogElement>("dialog.sheet")) {
  d.addEventListener("click", (e) => {
    if (e.target !== d) return;
    const r = d.getBoundingClientRect();
    const inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
    if (!inside) d.close();
  });
}

for (const btn of document.querySelectorAll<HTMLButtonElement>("button[data-copy]")) {
  btn.addEventListener("click", async () => {
    const text = document.getElementById(btn.dataset.copy!)?.textContent?.trim() ?? "";
    try {
      await navigator.clipboard.writeText(text);
      btn.textContent = "Copied";
      setTimeout(() => (btn.textContent = "Copy"), 1400);
    } catch {
      btn.textContent = "Select and copy";
    }
  });
}
